import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Form } from 'react-bootstrap';
import '../SignUp/SignUp.css';
import './OTPVerification.css';
const OTPVerification = () => {
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const [email] = useState('user@example.com'); // This would come from props or context
    const otpInputs = useRef([]);

    useEffect(() => {
        // Focus first input on mount
        if (otpInputs.current[0]) {
            otpInputs.current[0].focus();
        }
    }, []);

    const handleInputChange = (index, value) => {
        // Only allow numbers
        if (!/^\d*$/.test(value)) {
            return;
        }

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input if current is filled
        if (value && index < 5) {
            otpInputs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        // Move to previous input on backspace if current is empty
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            otpInputs.current[index - 1].focus();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const otpCode = otp.join('');

        if (otpCode.length !== 6) {
            alert('Please enter the complete 6-digit code!');
            return;
        }

        // Here you would typically verify the OTP with your backend
        console.log('OTP submitted:', otpCode);
        alert('Email verified successfully!');
    };

    const handleResendOTP = () => {
        // Here you would typically request a new OTP from your backend
        console.log('Resending OTP to:', email);
        alert('New verification code sent to your email!');

        // Clear current OTP
        setOtp(new Array(6).fill(''));
        if (otpInputs.current[0]) {
            otpInputs.current[0].focus();
        }
    };

    return (
        <div className="common-container d-flex justify-content-center align-items-center p-3 overflow-hidden fw-regular">
            <div className="common-card overflow-hidden my-0 mx-auto d-flex flex-column">
                {/* Header */}
                <div className="common-header text-center position-relative">
                    <div className="logo mb-1 fw-bold">
                        <i className="fas fa-rocket" style={{ marginRight: '0.5rem' }}></i>
                        ProjectFlow
                    </div>
                    <div className="logo-subtitle fw-regular">Streamline Your Projects</div>
                </div>

                {/* Body */}
                <div className="common-body d-flex flex-column">
                    <h1 className="common-title fw-bold mb-3 text-center">Verify Your Email</h1>

                    <div className="text-center">
                        <p className='mb-1'>We've sent a verification code to</p>
                        <p className="email fw-semibold text-primary mt-1 mb-0">{email}</p>
                    </div>

                    {/* OTP Form */}
                    <Form onSubmit={handleSubmit}>
                        <Row className="g-3">
                            <Col xs={12}>
                            <div className="otp-inputs d-flex justify-content-center mb-3 mt-4 gap-1 gap-md-2">
                                {otp.map((digit, index) => (
                                    <Form.Control
                                        key={index}
                                        ref={(el) => (otpInputs.current[index] = el)}
                                        type="text"
                                        className="otp-input mx-1 text-center fw-semibold"
                                        maxLength="1"
                                        pattern="[0-9]"
                                        inputMode="numeric"
                                        autoComplete="one-time-code"
                                        aria-label={`Digit ${index + 1}`}
                                        value={digit}
                                        onChange={(e) => handleInputChange(index, e.target.value)}
                                        onKeyDown={(e) => handleKeyDown(index, e)}
                                    />
                                ))}
                            </div>
                            </Col>
                            <Col xs={12}>
                                <Button type="submit" className="btn-primary w-100 mb-4">Verify</Button>
                            </Col>
                        </Row>
                    </Form>
                    <div className="resend-link d-flex align-items-center flex-wrap justify-content-center">
                        Didn't receive the code? <button type="button" onClick={handleResendOTP} className="btn btn-link text-decoration-none ms-1">Resend</button>
                    </div>
                    <div className="mt-2 text-center">
                        <Link to="/login" className='btn btn-link text-decoration-none'>Back to Sign In</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OTPVerification;
